import React from 'react'

export const FormViewContext = React.createContext({
  onFieldChange: undefined,
})

export default FormViewContext